export const copyright: string = '2022 Singapore Life Ltd. | Company Reg No: 196900499K | GST Reg No: MR-8500166-8';
export const references = [
  {
    url: 'https://singlife.com/en/terms-and-conditions',
    text: 'Terms of Use',
  },
  /* {
    url: 'https://singlife.com/en/privacy-policy',
    text: 'Privacy Policy',
  }, */
  {
    url: 'https://singlife.com/en/pdpa#cookiespolicy',
    text: 'Cookie Policy',
  },
  {
    url: 'https://singlife.com/en/pdpa',
    text: 'Personal Data Protection',
  },
  {
    url: 'https://singlife.com/en/security-practices',
    text: 'Security Practices',
  },
]